<div id="showFullTextModal" uk-modal #modal>
  <div class="uk-modal-dialog uk-modal-body">
    <button class="uk-modal-close-default" type="button" uk-close></button>
    <h2 class="uk-modal-title">{{ title }}</h2>
    <p class="text">{{ text }}</p>
  </div>
</div>
